<template>
	<div class="article">
		<a-checkbox :value="article.id" :disabled="(article.articleCategoryId == '55'||article.articleCategoryId == '216')"
			:checked="(article.articleCategoryId == 55||article.articleCategoryId == 216) ? false : article.checked"
			:class="checkButtonVisible == true ? 'artcileCheck' : 'artcileCheck noCheckBox'" @change="toCheck">
			<div class="article-content" :style="{ 'margin-left': checkButtonVisible == true ? '0px' : '' }">
				<a-row align="stretch" style="    border-bottom: 2px solid #e9eaec;">
					<a-col :span="18">
						
					<div :class="fontSize == 2 ? 'article-title text-overflow-1' : fontSize == 1 ? 'article-title titleSmall text-overflow-1' : 'article-title titleBig text-overflow-1'">
		
			
						<span :class="article.read ? 'article-title-off' : 'article-category-name'"
						v-if="article.articleCategory">[{{ article.articleCategory }}]</span>
						
							<a :class="article.read ? 'article-title-off' : ''" @click="clickAticle(article)">
								<template v-if="article.titleList&&article.titleList.length>0">
					<text v-for="title,titleIndex in article.titleList" :key="titleIndex" :class="article.read? 'article-title-off' : (titleIndex==0&&article.titleList.length>1?'article-title-name':'')">{{title}}</text>
				</template>

								
							</a>
			
					</div>
					<div :class="fontSize == 2 ?'article-text':fontSize == 1 ? 'article-text titleSmall' : 'article-text titleBig'">
					<span  v-if="article.introduction" >{{
			article.introduction }}</span>

				</div>
				<div style="display: flex;height: auto;" :class="fontSize == 2 ? 'article-text ' : fontSize == 1 ? 'article-text titleSmall' : 'article-text titleBig'"><span>时间：{{article.updateTime }} </span><span style="margin-left: 20px;">来源：{{article.source?article.source:'情报强企' }} </span></div>
				<Share :article="article"></Share>		
			</a-col>
					<a-col :span="6" style="    display: flex;align-items: center;    width: 100%;">
						<div class="article-image-box" style="    width: 100%;">
							
							<img v-if="getSrc(article)"  class="article-image" :src="getSrc(article)" mode="widthFix"
						border-radius="8" />
						</div>
					
				
					</a-col>
				</a-row>
			

			</div>
		</a-checkbox>
	
	</div>
</template>
<script>
import dayjs from 'dayjs'
import Share from './Share.vue'
import Sticky from './Sticky.vue'
import { created, ref, watch, onMounted } from 'vue'
import router from '@/router'
import store from '@/store'
export default {
	name: 'Article',
	props: {
		article: { type: Object, defalut: [] },
		updateTime: { type: String, defalut: "" },
		favor: { type: Boolean, defalut: false },
		zIndex: {
			type: [Number, String],
			default: 10
		},
		checkButtonVisible: { type: Boolean, defalut: false },
	},
	emits: ['returnChecked'],
	components: {
		Share, Sticky
	},
	setup(props, ctx) {
		watch(() => store.getters.fontSize, (val) => {
			fontSize.value = store.getters.fontSize
			if (document.querySelector('.sub-title'))
				timeWidth.value = document.querySelector('.sub-title').offsetWidth + 'px'
		})

		onMounted(() => {
			fontSize.value = store.getters.fontSize
			if (document.querySelector('.sub-title'))
				timeWidth.value = document.querySelector('.sub-title').offsetWidth + 'px'
			console.log(store.getters.company,'store.getters.company',store.getters.companyList)
			todayHomepageImg.value=store.getters.company.todayHomepageImg
		})
		const getDate = (type, timestamp) => {
			const date = dayjs(timestamp)
			if (type === 'week') {
				let week;
				if (date.day() == 0) { week = "星期日" } else
					if (date.day() == 1) { week = "星期一" } else
						if (date.day() == 2) { week = "星期二" } else
							if (date.day() == 3) { week = "星期三" } else
								if (date.day() == 4) { week = "星期四" } else
									if (date.day() == 5) { week = "星期五" } else
										if (date.day() == 6) { week = "星期六" }
				return week;
			} else if (type == 'mm月dd日') {
				return date.format("MM月DD日")
			}
			else if (type == 'hh:MM') {
				return date.format("HH:mm")
			}
		}
		const hideTime = ref(false)
		const clickAticle = (val) => {
			if (val.articleCategoryId == 216) {
				router.push({ name: 'weeklyArticleDetail', query: { warticleId: val.id } })
			}
			else if (val.productType == 5) {
				router.push({ name: 'catalogArticleDetail', query: { carticleId: val.id } })
			}
			else {
				router.push({ name: 'articleDetail', query: { articleId: val.id } })
			}
			if (!props.favor)
				props.article.read = true
		}
		const fontSize = ref('')
		const position = ref('static')
		const timeWidth = ref('')
		const toCheck = (val) => {
			ctx.emit('returnChecked', { value: val.target.value, checked: val.target.checked })

		}
		const todayHomepageImg=ref(null)
		const shareImgUrl=ref(null)
  const getSrc=(item)=>{
			return  (item.articleCategoryId==55?(todayHomepageImg.value?todayHomepageImg.value:item.shareImgUrl):(item.shareImgUrl||shareImgUrl.value))
		}
		return {
			todayHomepageImg,
			shareImgUrl,
			toCheck,
			timeWidth,
			position,
			clickAticle,
			hideTime,
			fontSize,
			dayjs,
			getDate,
			getSrc
		}
	},
	created() {

		if (this.updateTime && this.article.updateTime) {
			if (this.updateTime.split(' ')[0] === this.article.updateTime.split(' ')[0]) {
				this.hideTime = true
			}
			else {
				this.hideTime = false
			}
		}
		if (this.article.content && !this.article.shareImgUrl) {
			this.article.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/i, (match, capture) => {
				this.shareImgUrl = capture
				return match
			})
		}
	}
}
</script>
<style lang="css" scoped>
@media (min-width: 1600px) {
	.article-image{
		width:calc(100% - 150px) !important;
	}
}

</style>
<style lang="less">

.noCheckBox {

	.ant-checkbox {
		display: none;
	}
}
.artcileCheck{
	width: 100%;
	.ant-checkbox + span{
		flex: 1;
	}

}


</style>
<style lang="scss" scoped>


.text-overflow-1 {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
}
.text-overflow-2 {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
}

.article-title {
	a {
		color: #363839;
	}

	a:hover {
		color: #315efb !important;
	}
}

.article {

	color: #363839;

	.title {
		text-indent: 30px;
		position: relative;
		font-size: 20px;
		font-weight: bold;
		position: relative;
		background-color: #FFFFFF;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 16px;
			height: 16px;
			border-radius: 50%;
			background-color: #f0aa3c;
		}
	}

	.title.titleSmall {
		font-size: 18px;
		line-height: 36px;
		
	}

	.title.titleBig {
		font-size: 22px;
		line-height: 44px;
	}

	.sub-title {
		margin-top: 5px;
		text-indent: 30px;
		position: relative;
		font-size: 16px;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 7px;
			height: 7px;
			border-radius: 50%;
			border: 2px solid #f0aa3c;
		}
	}

	.sub-title.titleSmall {
		font-size: 14px;
		line-height: 28px;
	}

	.sub-title.titleBig {
		font-size: 18px;
		line-height: 36px;
	}

	.article-content {
		margin: 0px 30px;
	

		.article-category-name {
			margin-right: 10px;
			color: #00b2b9;
		}

		.article-title.titleSmall {
			font-size: 14px;
			line-height: 28px;
		}

		.article-title.titleBig {
			font-size: 18px;
			line-height: 36px;
		}

		.article-title {
			cursor: default;
			margin-top: 10px;
			font-size: 16px;
			font-weight: bold;

			// white-space: nowrap;
			// text-overflow: ellipsis;
			// overflow: hidden;
			// word-break: break-all;
			.article-title-off {
				font-weight: normal;
				// white-space: nowrap;
				// text-overflow: ellipsis;
				// overflow: hidden;
				// word-break: break-all;
				color: #a7adb0;
			}
			.article-title-name {
						color: #009DA6;
						font-weight: bold;
						margin-right: 10upx;
					}
		}

		.article-text.titleSmall {
			font-size: 12px;
			line-height: 24px;
			height: 48px;
		}

		.article-text.titleBig {
			font-size: 16px;
			line-height: 32px;
		}

		.article-text {
			color: #888e90;
		
			font-size: 14px;
			line-height: 28px;
			text-overflow: -o-ellipsis-lastline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			-webkit-box-orient: vertical;
			height: 56px;
		}
		
		.article-image-box {
		
			display: flex;
    		justify-content: center;
			.article-image {
				width:calc(100% - 50px);
				height: 120px;
			}
		}
	}
}
</style>